module.exports = __webpack_public_path__ + "static/media/cover-optimized.87d43748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/01-intro/assets/cover-optimized.jpg
// module id = 924
// module chunks = 0